import React, { useEffect } from "react";
import { observer } from "mobx-react-lite";
import { brokerAdminStore } from "../../pages/Broker/brokerAdminStore";

const getInitials = (text) => {
  const parts = String(text || "").trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return "–";
  return parts.slice(0, 2).map((part) => part[0]).join("").toUpperCase();
};

const isRawObjectId = (value) => /^[a-f0-9]{24}$/i.test(String(value || "").trim());

/**
 * Renders a broker administrator id as a readable name + avatar, resolved from
 * the mobx-backed brokerAdminStore (loaded once and shared across all rows).
 */
const BrokerAdminLabel = observer(({ id, fallback = "—", unresolvedFallback = "FV Bank team" }) => {
  useEffect(() => {
    brokerAdminStore.ensureLoaded();
  }, []);

  const safeFallback = isRawObjectId(fallback) ? unresolvedFallback : fallback;

  if (!id) {
    return <span className="broker-admin-label broker-admin-label--empty">{safeFallback}</span>;
  }

  const name = brokerAdminStore.getName(id);

  if (!name) {
    return <span className="broker-admin-label broker-admin-label--empty">{safeFallback}</span>;
  }

  return (
    <span className="broker-admin-label" title={name}>
      <span className="broker-admin-label__avatar" aria-hidden="true">{getInitials(name)}</span>
      <span className="broker-admin-label__name">{name}</span>
    </span>
  );
});

export default BrokerAdminLabel;
